import {
  ApplicationConfig,
  provideZonelessChangeDetection,
  APP_INITIALIZER,
  inject,
  ErrorHandler,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorToastInterceptor } from './core/interceptors/error-toast.interceptor';
import { AuthService } from './core/auth/auth.service';
import { ChunkErrorHandler } from './core/chunk-error-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor, errorToastInterceptor]),
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: (): (() => Promise<void>) => {
        const authService = inject(AuthService);
        return () => authService.init();
      },
      multi: true,
    },
    { provide: ErrorHandler, useClass: ChunkErrorHandler },
  ],
};
